import React, { useState, useEffect, useContext } from "react";
import DatePicker from "react-datepicker";
import Select from "./select";
import BranchContext from "./../context/branch";
import {
  getQueuetime,
  getStore,
  gettimeAll,
} from "./../../services/wms/grabconcept";
import { getSourceProduct } from "../../services/wms";

import dlv from "dlv";
import moment from "moment";
import Input from "./input";

const Queuecard = ({
  name,
  typename,
  store,
  head,
  allEditData,
  handleChangeStore,
  handleChangequeuetime,
  onChange,
  selected,
  onchangremark,
  handleSourceIdChange,
  proid,
  Typeid,
  customerid, handleChangefirstdriven, handleChangefirstdrivenprov
}) => {
  //console.log(props);

  const { currentBranch } = useContext(BranchContext);
  const obj = allEditData[0];
  //console.log('test',obj);
  let editStoreId = dlv(obj, "store_id", 0);
  let editQueueDate = dlv(obj, "queue_date1", new Date());
  let editsourceid = dlv(obj, "SourceProduct", 0);
  let editremark = dlv(obj, "comment", "");
  //let editQueueTime = dlv(obj, 'queue_time',"");
  if (editQueueDate == null) {
    editQueueDate = new Date();
  }
  const [sourceid, setsourceid] = useState(editsourceid);
  const [sourceproduct, setsourceproduct] = useState([]);
  const [storeId, setstoreId] = useState(editStoreId);
  const [timeId, settimeId] = useState("");

  const [remark, setremark] = useState(editremark);
  const [storeList, setstoreList] = useState([]);
  const [startDate, setStartDate] = useState(editQueueDate);
  const [queuetime, setqueuetime] = useState([]);
  //const [queuetimeb, setqueuetimeb] = useState([]);
  //const [startDateb, setStartDateb] = useState(editQueueDateb);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    const loadData = async () => {
      const { data: result } = await getStore(
        currentBranch && currentBranch._id
      );

      // getStore(( currentBranch._id)).then (result=>{
      //   setstoreList(result.data);
      if (result) {
        setstoreList(result);
      }
    };
    loadData();

    //  });
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getSourceProduct(
        currentBranch && currentBranch._id
      );

      //console.log(result);
      if (result) {
        setsourceproduct(result);
      }
    };
    loadData();
  }, [currentBranch]);
  // console.log("customerId",customerId)
  useEffect(() => {
    try {
      if (!currentBranch) return;
      const loadData = async () => {
        const { data: result } = await getQueuetime(
          moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
          currentBranch && currentBranch._id,
          proid,
          customerid,
          "",
          Typeid,handleChangefirstdriven,handleChangefirstdrivenprov
        );
        if (result) {
          setqueuetime(result);
          if (
            (currentBranch && currentBranch._id === "503") ||
            currentBranch._id === "502"
          ) {
            if (result && result.length > 0) {
              handleChangequeuetime(result[0].Times);         
            }
          }else if (result.length === 1) {
            settimeId(result[0].Times);
            handleChangequeuetime(result[0].Times);       
          }else {
             handleChangequeuetime("");
          }     
        }
      };
      loadData();
    } catch {
      setqueuetime([]);
    }
  }, [startDate, currentBranch, proid, Typeid, customerid,handleChangefirstdriven,handleChangefirstdrivenprov]);

  const onChangeDate = (event) => {
    // console.log(event);
    setStartDate(event);
    onChange(event);
  };

  const onhandleChangeStoreID = (event) => {
    //console.log("ssd",Typeid);
    setstoreId(event.currentTarget.value);
    handleChangeStore(event.currentTarget.value);
  };
  const onhandleChangequeuetime = ({ currentTarget: input }) => {
    settimeId(input.value);
    // console.log(input.value)
    handleChangequeuetime(input.value);
  };
  const handleRemarkTextchange = ({ currentTarget: input }) => {
    setremark(input.value);
    onchangremark(input.value);
  };
  const handleChangeSourceProduct = (event) => {
    setsourceid(event.currentTarget.value);
    handleSourceIdChange(event.currentTarget.value);
  };

  if (!currentBranch) {
    return <div></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card ">
            {/* <div className="card-header">{head}</div> */}
            <p className="bg-success text-white">
              <i className="fa fa-calendar ms-2 my-2" />

              <span> {head} </span>
            </p>

            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="typename">{typename}</label>
                    <div>
                      <DatePicker
                        className="datepicker-default form-control"
                        todayButton="Today"
                        dateFormat="dd/MM/yyyy"
                        selected={selected}
                        onChange={onChangeDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Select
                    label={name}
                    data={queuetime}
                    value={timeId}
                    textProperty="Times"
                    valueProperty="Times"
                    onChange={onhandleChangequeuetime}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      label={store}
                      data={storeList}
                      value={storeId}
                      textProperty="store_name"
                      valueProperty="Store_id"
                      onChange={onhandleChangeStoreID}
                    />
                  </div>
                </div>

                {((sourceproduct && sourceproduct.length > 0) ||
                  (currentBranch &&
                    currentBranch._id !== "501" &&
                    Typeid == "10")) && (
                  <div className="col-sm-6">
                    <div className="form-group">
                      {/* <Combobox/> */}

                      <Select
                        data={sourceproduct}
                        label={"แหล่งทีมา"}
                        value={sourceid}
                        textProperty="name"
                        valueProperty="_id"
                        onChange={handleChangeSourceProduct}
                      />
                    </div>
                  </div>
                )}

                <div className="col-sm-6">
                  <Input
                    name="remark"
                    value={remark}
                    label={"หมายเหตุ"}
                    onChange={handleRemarkTextchange}
                  />
                </div>
              </div>

              <div className="row"></div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Queuecard;
